import { fetchWithRetry } from '@/basedata/fetchWithRetry'
import { getStoredEventSlug, resolveEventSlugFromLocation } from '@/helpers/eventSlug'
import type { CaptureType } from '@/types/selfie'

export type SelfieConfig = {
  identityPoolId: string
  region: string
  mockLiveness: boolean
  captureType: CaptureType
}

let config: SelfieConfig | null = null

export const TEST_SELFIE_CONFIG: SelfieConfig = {
  identityPoolId: 'us-east-1:test-pool',
  region: 'us-east-1',
  mockLiveness: false,
  captureType: 'liveness',
}

export async function fetchSelfieConfig(): Promise<SelfieConfig> {
  // Modo evento: o eventSlug (URL foto.identila.com.br/<slug> / ?evento=) faz o
  // BFF resolver o captureType do tenant dono do evento.
  const eventSlug = resolveEventSlugFromLocation(window.location) ?? getStoredEventSlug()
  const query = eventSlug !== null ? `?eventSlug=${encodeURIComponent(eventSlug)}` : ''
  // Primeira chamada do app: sem repetição, o BFF que ainda não subiu (dev.sh,
  // cold start da Function) derrubava o bootstrap inteiro numa tela branca.
  const res = await fetchWithRetry(`/api/selfie/config${query}`)
  if (!res.ok) throw new Error(`Falha ao carregar configuração de selfie: ${res.status}`)
  config = (await res.json()) as SelfieConfig
  return config
}

export function getSelfieConfig(): SelfieConfig {
  if (config) return config
  if (import.meta.env.MODE === 'test') return TEST_SELFIE_CONFIG
  throw new Error('selfieConfig não inicializado — chame fetchSelfieConfig() primeiro')
}
